<div [ngClass]="getProgressIndicatorClass()">
  <div [ngClass]="getProgressIndicatorBarClassFor(25)"></div>
  <div [ngClass]="getProgressIndicatorBarClassFor(50)"></div>
  <div [ngClass]="getProgressIndicatorBarClassFor(75)"></div>
  <div [ngClass]="getProgressIndicatorBarClassFor(100)"></div>
</div>
